<template>
    <div class="maintain-sets">
        <el-row class="maintain-set-title">
            <el-col :span="3">
                <span class="h3">维护设置</span>
            </el-col>
            <el-col :span="6" class="maintain-set-list-filter" :offset="12">
                <el-form label-width="auto" :inline="true" size="mini">
                    <el-col>
                        <el-form-item :label="$t('tiao_jian_sou_suo')">
                            <el-input placeholder="请输入维护名称" class="maintain-set-input-filter"
                                      prefix-icon="el-icon-search" v-model="pagination.name"
                                      @change="loadMaintainSetSearch"></el-input>
                        </el-form-item>

                    </el-col>
                </el-form>
            </el-col>
            <el-col :span="3">
                <el-button size="mini" class="maintain-set-add" @click="createMaintainSetVisible=true">新增维护设置
                </el-button>
            </el-col>
        </el-row>
        <div class="maintain-set-data-list">
            <el-table :data="maintainSets">
                <el-table-column label="维护名称" align="center" prop="name"></el-table-column>
                <el-table-column label="设备周期费用上限(元)" align="center" prop="maxFee">
                </el-table-column>
                <el-table-column label="循环重置计费周期(天)" align="center" prop="resetPeriod"></el-table-column>
                <el-table-column label="工作时间" align="center">
                    <template slot-scope="scope">
                        <span class="maintain-set-time">{{scope.row.startHour}}时{{scope.row.startMinute}}分</span> ～
                        <span class="maintain-set-time">{{scope.row.endHour}}时{{scope.row.endMinute}}分</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center">
                    <template slot-scope="scope">
                        <span @click="handleEdit(scope.row)" class="maintain-set-edit">更多设置</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                class="pagination"
                :current-page="pagination.curPage"
                :page-size="pagination.limit"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
        </el-pagination>

        <c-dialog class="dialog" :visible.sync="createMaintainSetVisible" :width="'36rem'" :height="'24rem'"
                  :outer-close="false"
                  title="新增维护设置">
            <el-button slot="title" size="mini" type="primary" @click="createMaintain">{{$t('bao_cun')}}</el-button>
            <create ref="maintainCreate" :close="closeMaintainSetVisible"></create>
        </c-dialog>
    </div>

</template>

<script>
    import Create from './create'
    import CDialog from '@/components/Dialog'
    import {maintainSetDeviceParamTmplUnion, maintainSetDeviceParamTmplList} from '@/api/delivery/device/maintainSet'
    export default {
        name: '',
        components: {
            Create,
            CDialog
        },
        activated: function () {
            this.loadDeviceParamTmpl()
        },
        data: function () {
            return {
                maintainSets: [],
                pagination: {
                    start: 0,
                    curPage: 1,
                    limit: 8,
                    total: 0,
                    name: ''
                },
                createMaintainSetVisible: false,
            }
        },
        filters: {
            filterName(status) {
                switch (status) {
                    case 0:
                        return '离线'
                    case 1:
                        return '正常运行'
                    case 2:
                        return '待维护'
                    case 3:
                        return '待维修'
                }
            },
        },
        methods: {
            handleCurrentChange(value) {
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                maintainSetDeviceParamTmplList(this.pagination).then(res => {
                    this.maintainSets = this.transPrice(res.data || [])
                })
            },
            transPrice(data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].maxFee = parseFloat(data[i].maxFee / 100)
                    data[i].resetPeriod = parseFloat(data[i].resetPeriod / (24 * 3600))
                }
                return data
            },

            handleEdit(row) {
                this.$router.push({name: 'delivery.devices.maintainSet.detail', params: row})
            },

            loadDeviceParamTmpl() {
                let vue = this
                maintainSetDeviceParamTmplUnion(this.pagination).then(res => {
                    vue.maintainSets = this.transPrice(res.data.list || [])
                    vue.pagination.total = parseInt(res.data.total)
                })
            },
            createMaintain () {
                this.$refs.maintainCreate.createDeviceParamTmpl()
            },
            closeMaintainSetVisible() {
                this.createMaintainSetVisible = false
                this.loadDeviceParamTmpl()
            },
            loadMaintainSetSearch(){
                let vue = this
                this.pagination.curPage = 1
                this.pagination.start = 0
                maintainSetDeviceParamTmplUnion(this.pagination).then(res => {
                    vue.maintainSets = this.transPrice(res.data.list || [])
                    vue.pagination.total = parseInt(res.data.total)
                })
            },
        },
    }
</script>

<style lang="scss">
    .maintain-sets {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .maintain-set-title {
            .maintain-set-input-filter {
                input {
                    border: none;
                    border-bottom: 1px solid $f_fiv_color;
                    font-size: $filter-font-size;
                    border-radius: 0;
                }
            }
        }
        .maintain-set-data-list {
            margin-top: $padding;
            flex: 1;

            .maintain-set-info {
                .maintain-set-info-img {
                }
                .maintain-set-info-detail {

                    p {
                        margin-bottom: $padding-5;
                    }
                    p:first-child {
                        font-size: .8rem;
                    }
                }
            }

            .maintain-set-edit {
                color: $btn_color;
                cursor: pointer;
            }
        }

        .maintain-set-add {
            background-color: $btn_color;
            border: none;
            color: $f_th_color;
        }

        .pagination {
            margin: $padding;
        }
    }

</style>
